"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEventTypesResponseAllOfToJSON = exports.GetEventTypesResponseAllOfFromJSONTyped = exports.GetEventTypesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetEventTypesResponseAllOfFromJSON(json) {
    return GetEventTypesResponseAllOfFromJSONTyped(json, false);
}
exports.GetEventTypesResponseAllOfFromJSON = GetEventTypesResponseAllOfFromJSON;
function GetEventTypesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'eventTypes': (json['eventTypes'].map(_1.EventTypeFromJSON)),
    };
}
exports.GetEventTypesResponseAllOfFromJSONTyped = GetEventTypesResponseAllOfFromJSONTyped;
function GetEventTypesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'eventTypes': (value.eventTypes.map(_1.EventTypeToJSON)),
    };
}
exports.GetEventTypesResponseAllOfToJSON = GetEventTypesResponseAllOfToJSON;
